import { SlBarGraphData } from '@varo/graphql-schema-types';
import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';

import BarChart, { BarChartProps } from './BarChart/BarChart';

const IncomeChart = ({ data }: BarChartProps) => {
  const updatedIncomeData = updateIncomeData(data);
  if (updatedIncomeData) {
    return <BarChart data={updatedIncomeData} />;
  }
  return <View style={styles.container} />;
};

const updateIncomeData = (data: SlBarGraphData) => {
  const { yScale, bars } = data;
  const { maxValue } = yScale;

  if (
    typeof maxValue !== 'number' ||
    isNaN(maxValue) ||
    !bars ||
    !Array.isArray(bars)
  ) {
    return null;
  }

  const maximumValue = (2 / 100) * maxValue;

  const updatedIncome: SlBarGraphData = {
    ...data,
    bars: bars.map((bar) => {
      if (!bar.segments || !Array.isArray(bar.segments)) {
        return bar;
      }

      return {
        ...bar,
        segments: bar.segments.map((segment) => {
          const segmentAmount = parseFloat(segment.amount?.amount as string);

          if (isNaN(segmentAmount)) {
            return segment;
          }

          return {
            ...segment,
            amount:
              segmentAmount < maximumValue
                ? {
                    amount: maximumValue,
                    currency: 'USD',
                    formatted: `$${maximumValue}`,
                    formattedWithPlusPrefix: `+$${maximumValue}`,
                    formattedWithPlusPrefixOrAbs: `+$${maximumValue}`,
                  }
                : segment.amount,
          };
        }),
      };
    }),
  };

  return updatedIncome;
};

const styles = StyleSheet.create({
  container: {
    height: 250,
    width: '100%',
  },
});

export default memo(IncomeChart);
